/*! @azure/msal-common v13.0.0 2023-05-01 */
'use strict';
/* eslint-disable header/header */
var name = "@azure/msal-common";
var version = "13.0.0";

export { name, version };
//# sourceMappingURL=packageMetadata.js.map
